import Typography from "@mui/material/Typography"

import { formatNumber } from "../../utils"

export default function ResultsPositionFromTotal({
  pageIndex,
  pageSize,
  rows,
  totalCount,
}) {
  const startingRowIndex = rows.length === 0 ? 0 : 1
  const startingPosition = (pageIndex - 1) * pageSize + startingRowIndex
  return (
    <Typography variant="body2" sx={{ display: { sm: "inline" } }}>
      Showing <strong>{startingPosition}</strong> -{" "}
      <strong>{startingPosition + rows.length - startingRowIndex}</strong> of{" "}
      <strong>{formatNumber(totalCount)}</strong> results
    </Typography>
  )
}
